import {FC} from 'react'
import RemoveDiscount from './RemoveDiscount'
import DiscountButton from './DiscountButton'

type Props = {
  title: string | any
  discountCodeId?: string | any
  onRemoveDiscount?: (discountCodeId: string | any) => any
  onClick: () => void
}

const PromoCode: FC<Props> = ({
  title = {btn: null, name: 'Discount'},
  discountCodeId,
  onRemoveDiscount,
  onClick,
}) => {
  return (
    <>
      {discountCodeId && onRemoveDiscount ? (
        <RemoveDiscount
          title={title.name}
          onRemoveDiscount={onRemoveDiscount}
          discountCodeId={discountCodeId}
        />
      ) : (
        <DiscountButton title={title} onClick={onClick} />
      )}
    </>
  )
}
export default PromoCode
